import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import CustomizedHook from "../../project/autocomplatePro";
import { InputCreateProject } from "../../project/createProjectPop";
import DrugTable from "./drugTable";
import DatePicker from "../../project/datePicker";
import { useEffect } from "react";
import { getDrugTypes, postStoreOneDrug } from "../../../api/group";
import Uploader from "./uploader";
import { ArrowBack } from "@mui/icons-material";
import FormDrug from "./formDrug";

export default function NewDrug({ mode, setMode }) {
  const [dataTable, setDataTable] = useState([]);
  // var dataTable = [];
  const [selectType, setSelectType] = useState(0);
  const [date, setDate] = useState();

  const [dataForm, setDataForm] = useState({
    name: "",
    producer: "",
    expireAt: "",
    location: "MAIN",
    drugType: "TAB",
    available: "",
    availablePack: "",
    price: "",
    shelfNo: "",
    boxNo: "",
    dose: "",
  });

  // console.log(drugType);
  return (
    <Box mt="30px">
      <Box
        display={"flex"}
        alignItems="center"
        justifyContent={"space-between"}
      >
        <Typography mb="20px" className="title_GroupOnline">
          {"داروی جدید"}
        </Typography>
        <Box
          sx={{
            cursor: "pointer",
            color: "var(--emr-darkblue)",
          }}
          onClick={() => {
            setMode("table");
          }}
        >
          <ArrowBack />
        </Box>
      </Box>
      <Box
        borderRadius="10px"
        bgcolor={"white"}
        width={"fit-content"}
        p="5px"
        display={"flex"}
        gap="3px"
        sx={{ cursor: "pointer" }}
      >
        <Box
          borderRadius="0px 10px 10px 0px"
          bgcolor={selectType === 0 ? "#125383" : "white"}
          p="5px 10px"
          color={selectType === 0 ? "white" : "black"}
          sx={{ transition: "0.3s all" }}
          onClick={() => setSelectType(0)}
        >
          افزودن تکی
        </Box>
        <Box
          borderRadius="10px 0px 0px 10px"
          bgcolor={selectType === 1 ? "#125383" : "white"}
          p="5px 10px"
          color={selectType === 1 ? "white" : "black"}
          sx={{ transition: "0.3s all" }}
          onClick={() => setSelectType(1)}
        >
          افزودن گروهی
        </Box>
      </Box>
      {selectType === 0 && (
        <Box
          mt="20px"
          border="solid 2px #6C8C97 "
          borderRadius={"13px"}
          width={"calc( 100% - 40px )"}
          // height="200px"
          p="40px 20px"
        >
          <FormDrug
            dataForm={dataForm}
            setDataForm={setDataForm}
            date={date}
            setDate={setDate}
          />
          {/* <Box display={"flex"} flexWrap="wrap" gap="10px">
            <Box width={"250px"}>
              <CustomizedHook
                multiple
                placeholder={"انتخاب کنید."}
                label="نوع دارو"
                options={drugType}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setDataForm({ ...dataForm, drugType: newValue.value });
                  }
                }}
                // value={
                //   states.find((state) => state.name === stepOne.state) ||
                //   dataLoc?.states ||
                //   null
                // }
              />
            </Box>
            <InputCreateProject
              placeholder={"تاریخ انقضا دارو"}
              label="تاریخ انقضا"
              onClick={(e) => {
                setShowDatePicker(e.currentTarget);
              }}
              value={date ? `${date.year}/${date.month}/${date.day} ` : ""}
              //   onChange={(e) => setTripName(e.target.value)}
            />
            <InputCreateProject
              placeholder={"نام دارو را وارد کنید."}
              label="اسم دارو"
              onChange={(e) =>
                setDataForm({ ...dataForm, name: e.target.value })
              }
              value={dataForm?.name || ""}
            />
            <InputCreateProject
              placeholder={"دوز دارو را وارد کنید"}
              label="دوز دارو"
              onChange={(e) =>
                setDataForm({ ...dataForm, dose: e.target.value })
              }
              value={dataForm?.dose || ""}
            />
            <InputCreateProject
              placeholder={"شرکت سازنده دارو را وارد کنید"}
              label="شرکت سازنده"
              onChange={(e) =>
                setDataForm({ ...dataForm, producer: e.target.value })
              }
              value={dataForm?.producer || ""}
            />
            <Box width={"250px"}>
              <CustomizedHook
                multiple
                placeholder={"انتخاب کنید."}
                label="محل دارو"
                options={[{ value: "SMALL" }, { value: "LARGE" }]}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setDataForm({ ...dataForm, location: newValue.value });
                  }
                }}
              />
            </Box>
            <InputCreateProject
              placeholder={"تعداد دارو را وارد کنید"}
              label="تعداد دانه"
              onChange={(e) =>
                setDataForm({ ...dataForm, available: Number(e.target.value) })
              }
              value={dataForm?.available || ""}
              type="number"
            />
            <InputCreateProject
              placeholder={"تعداد بک دارو را وارد کنید"}
              label="تعداد پک"
              onChange={(e) =>
                setDataForm({
                  ...dataForm,
                  availablePack: Number(e.target.value),
                })
              }
              value={dataForm?.availablePack || ""}
              type="number"
            />
            <InputCreateProject
              placeholder={"مبلغ دارو را وارد کنید"}
              label="مبلغ یک دانه"
              onChange={(e) =>
                setDataForm({ ...dataForm, price: Number(e.target.value) })
              }
              value={dataForm?.price || ""}
              type="number"
            />
            <InputCreateProject
              placeholder={"مبلغ کل دارو را وارد کنید"}
              label="مبلغ کل"
              value={dataForm?.price * dataForm?.available || ""}
            />
            <InputCreateProject
              placeholder={"شماره دارو را وارد کنید"}
              label="شماره جعبه"
              onChange={(e) =>
                setDataForm({ ...dataForm, boxNo: e.target.value })
              }
              value={dataForm?.boxNo || ""}
            />
            <InputCreateProject
              placeholder={"شماره قفسه دارو را وارد کنید"}
              label="شماره قفسه"
              onChange={(e) =>
                setDataForm({ ...dataForm, shelfNo: e.target.value })
              }
              value={dataForm?.shelfNo || ""}
            />
          </Box> */}
          <Box mt="20px" gap="10px" display={"flex"}>
            <button
              style={{
                border: "none",
                color: "white",
                background: "#125383",
                width: "100px",
                padding: "10px 0px",
                borderRadius: "10px",
              }}
              onClick={() => {
                // dataTable.push("mmd");
                setDataTable([dataForm]);
                // setDataForm({
                //   name: "",
                //   producer: "",
                //   expireAt: "",
                //   location: "SMALL",
                //   drugType: "TAB",
                //   available: "",
                //   availablePack: "",
                //   price: "",
                //   shelfNo: "",
                //   boxNo: "",
                //   dose: "",
                // });
              }}
            >
              ذخیره دارو
            </button>
            <button
              style={{
                border: "none",
                color: "white",
                background: "#126E83",
                width: "100px",
                padding: "10px 0px",
                borderRadius: "10px",
              }}
              onClick={() => {
                if (dataTable.length === 1) {
                  postStoreOneDrug(dataTable[0])
                    .then(() => {
                      setMode("table");
                    })
                    .catch(() => {});
                }
              }}
            >
              ثبت دارو
            </button>
          </Box>
          <Box mt="30px">
            {dataTable?.length > 0 && (
              <DrugTable create date={date} rowData={dataTable} />
            )}
          </Box>
        </Box>
      )}
      {selectType === 1 && (
        <Box>
          <Uploader setMode={setMode} />
        </Box>
      )}
    </Box>
  );
}
